import globalLogger from "@lazarentertainment/js-logger";
import { z } from "zod";
import { TypedStorage } from "./util/typedStorage";
export const chatParsers = {
    displayName: z.string().min(1).nullable().parse,
};
export const CHAT_LOCAL_STORAGE_NAMESPACE = "producer.local_chat_data";
export function createChatStorage({ logger = globalLogger, storage = window.localStorage, } = {}) {
    return new TypedStorage({
        namespace: CHAT_LOCAL_STORAGE_NAMESPACE,
        logger,
        storage,
        window,
        parsers: chatParsers,
    });
}
